import React from "react";
import { arrayOf } from "prop-types";
import { unitShape } from "../../common/unit.js";

const propTypes = {
  units: arrayOf(unitShape),
};

const defaultProps = {
  units: [],
};

const FloorPlanUnitList = props => {
  const { units } = props;

  return (
    <div className="floor-plan-detail--units">
      {units.map(unit => {
        const {
          area,
          availableDate,
          displayDate,
          bathrooms,
          bedrooms,
          floorPlan,
          id,
          price,
          unitNumber,
          url,
        } = unit;

        const date = new Date(availableDate);
        const now = new Date();
        const moveInText =
          date < now ? "Available Now" : `Move-in ${displayDate}`;

        return (
          <div className="floor-plan-detail--unit" key={id}>
            <div className="fpd-unit">
              <div className="fpd-unit__title coh-style-color-1 coh-style-border-bottom-color-1 coh-style-heading-3-alt-size">
                Apartment {unitNumber}
              </div>
              <div className="fpd-unit__details">
                <div className="fpb-unit__details-col">
                  <div className="fpd-unit__price coh-style-heading-5-size">
                    Price: {price}
                  </div>
                  <div className="fpd-unit__floor-plan coh-style-heading-5-size">
                    Plan: {floorPlan}
                  </div>
                </div>
                <div className="fpb-unit__details-col coh-style-heading-5-size">
                  <ul className="fpb-unit__list">
                    <li>{area} Sq. Ft.</li>
                    <li>{bedrooms}</li>
                    <li>{bathrooms}</li>
                  </ul>
                </div>
                <div className="fpb-unit__details-col coh-style-heading-5-size">
                  <ul>
                    <li>{moveInText}</li>
                  </ul>
                </div>
                <div className="fpb-unit__details-col coh-style-heading-5-size">
                  <a href={url} className="coh-style-link-button---filled" aria-label={`Apartment ${unitNumber} Details`}>
                    Details
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

FloorPlanUnitList.defaultProps = defaultProps;
FloorPlanUnitList.propTypes = propTypes;
export default FloorPlanUnitList;
